import { InventoryLookup } from '@services';

/** The extra a service gets when a stock item is picked from the inventory lookup. */
export const inventoryToServicePart = (item: InventoryLookup) => ({
  name: item.name,
  number: item.partNumber,
  reference: item.reference,
  costPrice: item.costPrice,
  price: item.sellPrice,
  quantity: 1,
  margin: item.sellPrice > 0 ? ((item.sellPrice - item.costPrice) / item.sellPrice) * 100 : 0,
  type: item.categoryName || 'Part',
  inventoryId: item.id,
  availableStock: item.quantity,
  required: false,
});
